// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1u8k7","text":"SelectPayment_text__1LkG5","title":"SelectPayment_title__381Wq","btn":"SelectPayment_btn__1fWYF"};